class t{constructor(){if(new.target===t)throw new TypeError("Cannot construct abstract Mapper instances directly")}static _getResult(t,r){return r?r(t):t}}export{t as Mapper};
//# sourceMappingURL=mapper.js.map
